<template>
    <div class="setting-page-content-wrapper notification-settings">
        <div class="page-header">
            <div class="title">{{ $t("search.allNotificationSettings") }}</div>
            <div class="subtitle">{{ $t("notification.notificationSettingsDesc") }}</div>
        </div>
        <section>
            <BasicActions
                :settings="settings"
                @update="updateScopeNotificationSettings"
                :title="group.title"
                v-for="group of groups"
                :key="group.id"
                :allowed-scopes="group.allowedScopes"
            />
        </section>
    </div>
</template>
<script>
import Vue from "vue";
import BasicActions from "./BasicActions.vue";
import { ACTIVITY_API } from "../../../../../api/activity";

export default Vue.extend({
    name: "NotificationSettings",
    components: { BasicActions },
    data() {
        return {
            loading: false,
            settings: [],
            groups: [
                {
                    id: "basic",
                    title: this.$t("notification.basicActions"),
                    allowedScopes: [
                        "chat-assign",
                        "ticket-assign",
                        // "task-assign",
                        "chat-close-own",
                        "contact-owner",
                    ],
                },
                {
                    id: "supsis-crm",
                    title: this.$t("notification.crmActions"),
                    allowedScopes: [
                        "tag-actions-to-visitor",
                        "create-ticket",
                        "note-actions-to-visitor",
                        "visitor-profile-updates",
                    ],
                },
                {
                    id: "company",
                    title: this.$t("notification.companyActions"),
                    allowedScopes: [
                        "chat-start",
                        "user-crud",
                        "department-crud",
                        "settings-crud",
                        "integration-channel-crud",
                        "login-form-crud",
                        "banned-word-crud",
                        "email-account-crud",
                        "prepared-content-crud",
                        "role-crud",
                        "tag-crud",
                        "welcome-message-crud",
                        "webhook-crud",
                        "billing-events",
                        // "task-workflow-crud",
                        // "task-crud",
                        "system-status",
                        "reservation-events",
                        "white-list-events",
                    ],
                },
                {
                    id: "task",
                    title: this.$t("message.taskModule"),
                    allowedScopes: [
                        "task-crud",
                        "task-created",
                        "task-deleted",
                        "task-workflow-created",
                        "task-workflow-crud",
                        "task-assign",
                        "task-complet",
                        "task-archive",
                    ],
                },
                {
                    id: "chatbot",
                    title: this.$t("notification.chatbotActions"),
                    allowedScopes: [
                        "chatbot-story-crud",
                        "chatbot-forward-chat",
                        "chatbot-user-segment-crud",
                        "chatbot-credit-low",
                    ],
                },
                {
                    id: "whatsapp",
                    title: this.$t("notification.whatsappActions"),
                    allowedScopes: [
                        "whatsapp-credit-low",
                        "whatsapp-customer-group-crud",
                        "whatsapp-broadcast-message-crud",
                        "whatsapp-template-message-crud",
                        "whatsapp-qr-code-status",
                    ],
                },
            ],
        };
    },
    mounted() {
        this.fetchSettings();
    },
    methods: {
        updateScopeNotificationSettings(item, platform, value) {
            this.settings = this.settings.map((setting) => {
                if (setting.scope === item) {
                    setting[platform] = value;
                }
                return setting;
            });
        },
        fetchSettings() {
            this.loading = true;
            ACTIVITY_API.NOTIFICATION.getMySettings()
                .then((res) => {
                    this.settings = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
});
</script>

<style scoped lang="scss">
.notification-settings {
    padding: 10px;
    .page-header {
        display: flex;
        flex-direction: column;
        gap: 10px;
        border-bottom: 1px solid var(--color-border-default);
        padding-bottom: 10px;

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            font-weight: 400;
            color: var(--color-text-default);
        }
    }
}
</style>
